// safetyFormLists/nearMissLists/actions.js

import { getUserNearMissFormList } from "../../../api/SafetyFormApi";
import { nearMissListInitialState } from "./safetyFormListsNearMissListsState";
import { makeFiltersActions } from "../../shared/filters/filtersActions";

export const makeNearMissListActions = (set, get) => ({
  setNearMissListPage: ({ currentPage, pageSize }) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        nearMissList: {
          ...s.safetyFormLists.nearMissList,
          currentPage,
          pageSize,
        },
      },
    })),

  setNearMissListPageSize: (pageSize) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        nearMissList: {
          ...s.safetyFormLists.nearMissList,
          pageSize,
          currentPage: 1,
        },
      },
    })),

  setSelectedNearMiss: (nearMiss) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        nearMissList: {
          ...s.safetyFormLists.nearMissList,
          selectedNearMiss: nearMiss,
        },
      },
    })),

  deleteNearMissLocal: (id) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        nearMissList: {
          ...s.safetyFormLists.nearMissList,
          items: s.safetyFormLists.nearMissList.items.filter(
            (n) => n.id !== id
          ),
        },
      },
    })),

  upsertNearMissLocal: (nearMiss) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        nearMissList: {
          ...s.safetyFormLists.nearMissList,
          items: [...s.safetyFormLists.nearMissList.items, nearMiss],
        },
      },
    })),

  resetNearMissList: () =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        nearMissList: nearMissListInitialState,
      },
    })),

  ...makeFiltersActions(set, get, "NearMissListDrafts"),

  fetchNearMissListDraftsPage: async (employeeId, externalFilters = null) => {
    // Using only state parameters since they contain the current pagination and filter values
    const {
      safetyFormLists: {
        nearMissList: { currentPage, pageSize, filters },
      },
    } = get();
    const effectiveFilters = externalFilters || filters;

    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        nearMissList: {
          ...s.safetyFormLists.nearMissList,
          loading: true,
          error: null,
        },
      },
    }));

    try {
      const r = await getUserNearMissFormList(
        employeeId,
        currentPage,
        pageSize,
        effectiveFilters
      );
      set((s) => ({
        safetyFormLists: {
          ...s.safetyFormLists,
          nearMissList: {
            ...s.safetyFormLists.nearMissList,
            loading: false,
            items: r.data || [],
            totalCount: r.total_count || 0,
          },
        },
      }));
    } catch (err) {
      console.error("Failed to fetch near miss list drafts page:", err);
      set((s) => ({
        safetyFormLists: {
          ...s.safetyFormLists,
          nearMissList: {
            ...s.safetyFormLists.nearMissList,
            loading: false,
            error: err.message,
          },
        },
      }));
    }
  },

  upsertNearMissDraftLocal: (row) =>
    set((s) => {
      const existingItems = s.safetyFormLists.nearMissList.items;
      const existingIndex = existingItems.findIndex(
        (item) => String(item.id) === String(row.id)
      );

      let newItems;
      let newTotalCount;

      if (existingIndex >= 0) {
        // Update existing row
        newItems = [...existingItems];
        newItems[existingIndex] = { ...newItems[existingIndex], ...row };
        newTotalCount = s.safetyFormLists.nearMissList.totalCount;
      } else {
        // Insert new row
        newItems = [...existingItems, row];
        newTotalCount = s.safetyFormLists.nearMissList.totalCount + 1;
      }

      return {
        safetyFormLists: {
          ...s.safetyFormLists,
          nearMissList: {
            ...s.safetyFormLists.nearMissList,
            items: newItems,
            totalCount: newTotalCount,
          },
        },
      };
    }),

  removeNearMissDraftLocal: (id) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        nearMissList: {
          ...s.safetyFormLists.nearMissList,
          items: s.safetyFormLists.nearMissList.items.filter(
            (n) => n.id !== id
          ),
          totalCount: s.safetyFormLists.nearMissList.totalCount - 1,
        },
      },
    })),
});
